import { useLingui } from '@lingui/react/macro';
import type { ReactNode } from 'react';
import fastBackground from './assets/fast.webp?w=450&quality=95&format=png&effort=max&img';
import secureBackground from './assets/secure.webp?w=450&quality=95&format=png&effort=max&img';

export type WhyChooseUs = {
  key: string;
  title: ReactNode;
  description: ReactNode;
  background: string;
};

export const useWhyChooseUsList = (): WhyChooseUs[] => {
  const { t } = useLingui();
  return [
    {
      key: 'fast',
      title: t`Fast & Simple UX`,
      description: t`Smooth onboarding, real-time swaps, and a UI that actually makes sense.`,
      background: fastBackground,
    },
    {
      key: 'secure',
      title: t`Trusted & Secure`,
      description: t`Fully compliant, with institutional-grade encryption and KYC options.`,
      background: secureBackground,
    },
  ];
};
